<template>
  <kab-join>
    <template #content>
      <join-event-form
        v-if="!success"
        :errors="errors"
        :countries="countryOptions"
        :reset-form="clearForm"
        @success="showSuccess"
      />
    </template>
  </kab-join>
</template>

<script>
import KabJoin from "@/components/KabJoin"
import JoinEventForm from "@/components/JoinEventForm"
import { mapGetters, mapState } from 'vuex'
export default {
  name: "Contact",
  components: {
    JoinEventForm,
    KabJoin
  },
  data () {
    return {
      success: false,
      clearForm: false
    }
  },
  computed: { 
    ...mapState([
      'errors'
    ]),
    ...mapGetters([
      'countryOptions'
    ])
  },
  async created() {
    await this.getCountries()
  },
  methods: {
    async showSuccess (value) {
      this.success = value
      await this.$nextTick()
      window.location.replace('/tour')
    },
    resetFrom (value) {
      this.success = false
      this.clearForm = value
    },
    async getCountries() {
      try {
        await this.$store.dispatch('getCountries')
      } catch (error) {
        throw Error(error)
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.joint-event-container {
  width: 100%;
  h1 {
    font-size: 66px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    margin-top: 36px;
  }

  .kabs-bg-image {
    object-fit: contain;
    background-blend-mode: multiply;
    background-image: linear-gradient(to bottom, #b42476, #6a0043);
  }
  .kabs-content {
    margin: auto 10% 25px 14%;
    min-height: 48vh;
  }
  .contact-headline {
    margin-top: 29px;
    text-align: left;
    h1 {
      margin: 0;
      font-size: 50px;
      font-weight: bold;
      line-height: 1.28;
      color: #000000;
    }
    p {
      font-size: 16px;
      line-height: 1.5;
      color: #000000;
    }
  }
}
@media only screen and (max-width: 600px) {
  .contact-container {
    h1 {
      font-size: 40px !important;
      margin-top: 30px !important;
    }
    .kabs-content {
      margin: auto 10% 25px 10%;
    }
  }
}
</style>
